import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import Loading from "~/components/Loading";
import { useProjectCostsFeature } from "~/hooks/useProjectCostsFeature";
import { ROUTE_404 } from "~/router/constants";

/**
 * Flag gate for the project Costs route, so a direct link outside the rollout
 * 404s like any unknown page. Waits for Flipt rather than redirecting on its
 * initial `false`.
 */
export const ProjectCostsFeatureRoute = ({ children }: { children: ReactNode }) => {
  const { enabled, isLoading } = useProjectCostsFeature();

  if (isLoading) {
    return <Loading />;
  }
  if (!enabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <>{children}</>;
};
